// // import { signInWithGoogle } from "./firebase";

// import { GMAIL_REGISTER } from "../common/URLs";

// // export const userGoogleAuth = async () => {
// //   try {
// //     const user  = await signInWithGoogle();
// //     console.log('User Info:', user);
// //     // console.log('user:', user.email);
// //     // console.log('Display Name:', user.displayName);
// //     return user
// //     // You can set the user info in your state or context here
// //   } catch (error) {
// //     console.error('Error during Google login:', error);
// //   }
// // };

// export const GoogleCreate = async (userData) => {
//   console.log("userdata in api", userData)

//   const response = await fetch(GMAIL_REGISTER, {
//     method: 'POST',
//     body: JSON.stringify(userData),
//     headers: {
//       'Content-Type': 'application/json',
//     },
//   });

//   if (!response.ok) {
//     const errorText = await response.text();
//     const errorData = JSON.parse(errorText);
//     if (response.status === 422) {
//       console.log("error field is", errorData.errors[0])
//     }
//     throw new Error(`${errorData.errors[0]}`);
//   }

//   const responseBody = await response.json();
//   console.log("responseBody:- ", responseBody);

//   // Only set cookie if user type is candidate
//   if (responseBody?.user?.user_type === "employer") {
//     // Convert the entire response object to a JSON string  
//     const cookieValue = JSON.stringify(responseBody);

//     // Create a cookie with the JSON string of the response data  
//     document.cookie = `userToken=${encodeURIComponent(cookieValue)}; path=/; max-age=${7 * 24 * 60 * 60 * 1000}`;
//   }

//   return responseBody;
// };





import { GMAIL_REGISTER } from "../common/URLs";

const setUserCookie = (obj) => {
  // Store full response JSON so fetchCookie can parse user.user.user_type
  const cookieValue = JSON.stringify(obj);
  // Max-Age is in SECONDS
  document.cookie = `userToken=${encodeURIComponent(cookieValue)}; Path=/; Max-Age=${7 * 24 * 60 * 60}; `;
};

export const GoogleCreate = async (userData) => {

  const response = await fetch(GMAIL_REGISTER, {
    method: "POST",
    body: JSON.stringify(userData),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    const errorData = JSON.parse(errorText);
    if (response.status === 422) {
      console.error("error field is", errorData.errors[0]);      
    }
    throw new Error(`${errorData.errors[0]}`);
  }

  const responseBody = await response.json();

  // Set cookie with full JSON user data if present
  if (responseBody?.user?.user_type === "employer") {
    setUserCookie(responseBody);
  }

  return responseBody;
};

export const createUser = async (userData) => {
  const response = await fetch("https://api.indiahirings.com/api/auth/register", {
    method: "POST",
    body: JSON.stringify(userData),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    const errorData = JSON.parse(errorText);
    if (response.status === 422) {
      console.error("error field is", errorData.errors[0]);
    }
    throw new Error(`${errorData.errors[0]}`);
  }

  const responseBody = await response.json();

  // IMPORTANT: Do NOT set cookie here. Some registration APIs don't return a full user object.
  // We'll auto-login right after signup to set a proper cookie.

  return responseBody;
};

export const loginUser = async (userData) => {
  try {
    const response = await fetch("https://api.indiahirings.com/api/auth/login", {
      method: "POST",
      body: JSON.stringify(userData),
      headers: {
        "content-type": "application/json",
      },
    });

    if (!response.ok) {
      if (response.status === 401) {
        // Invalid email or password
      }
      const errorText = await response.text();
      const errorData = JSON.parse(errorText || "{}");
      throw new Error(errorData?.error?.[0] || "Login failed");
    }

    const data = await response.json();

    // Set cookie with the full response object
    if (data?.user?.user_type === "employer") {
      setUserCookie(data);
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const logout = async (accessToken) => {
  try {
    const response = await fetch("https://api.indiahirings.com/api/auth/logout", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
        Accept: "application/json",
      },
    });
    const data = await response.json();

    return data;
  } catch (error) {
    console.error("error ", error);
    return error;
  }
};